import Promo from '~/types/Promo';
import { ActionKeys } from './constants';

export function fetchPromoByCode(code: string) {
  return <const>{
    code,
    type: ActionKeys.FETCH_PROMO_BY_CODE,
  };
}

// TODO: Non standard name. Rename.
export function didFetchPromo(promo: Promo) {
  return <const>{
    promo,
    type: ActionKeys.DID_FETCH_PROMO,
  };
}

export function fetchPromoFailed(error: Error) {
  return <const>{
    error,
    type: ActionKeys.FETCH_PROMO_FAILED,
  };
}

export function applyOrReplacePromoCode(code: string, isReplacement: boolean) {
  return <const>{
    code,
    isReplacement,
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE,
  };
}

export function applyOrReplacePromoCodeSuccess() {
  return <const>{
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_SUCCESS,
  };
}

export function applyOrReplacePromoCodeError(error: Error) {
  return <const>{
    error,
    type: ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_ERROR,
  };
}

export type PromoActions =
  | ReturnType<typeof fetchPromoByCode>
  | ReturnType<typeof didFetchPromo>
  | ReturnType<typeof fetchPromoFailed>
  | ReturnType<typeof applyOrReplacePromoCode>
  | ReturnType<typeof applyOrReplacePromoCodeSuccess>
  | ReturnType<typeof applyOrReplacePromoCodeError>;
